import { lazy } from 'react';

export * from './form';

const List = lazy(() => import('./list'));
const Details = lazy(() => import('./details'));

export { List, Details };
